import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfigService } from 'src/app/services/config/config.service';

export class TestSendEmailRequest {
  email: string;
  emailTempleteFile: string;
  subject:string;
}
export class TestSendEmailResponse {
  message: string;
  status: boolean;
}

@Component({
    selector: 'app-email-sender',
    templateUrl: './email-sender.component.html',
    styleUrls: ['./email-sender.component.css'],
    standalone: false
})
export class EmailSenderComponent {
  emailForm: FormGroup;
  viewmodel=new TestSendEmailRequest();
  constructor(private fb: FormBuilder, private configService: ConfigService) {
    this.emailForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      emailTemplateFile: ['EvidantEmailTest.html', Validators.required],
      subject: ['', Validators.required],
    });
  }

  async onSubmit() {
    if (this.emailForm.valid) {
      const request = this.emailForm.value as TestSendEmailRequest;

      try {
        const result = await this.configService.testEmail(request);
        if (result.status) {
          alert('Email sent successfully!');
          //this.emailForm.reset();
        } else {
          console.error('Error sending email:', result.message);
          alert('Failed to send email. Please try again later.');
        }
      } catch (error) {
        console.error('Error:', error);
        alert('An error occurred while sending the email.');
      }
    }
  }
}
